// @flow
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Widget from 'app/components/Widget';
import BulletList from 'app/components/BulletList';
import styles from './WidgetTopNews.styles';

class WidgetTopNews extends React.Component<Props> {
    constructor(props) {
      super(props);

      this.state = {
        lists: []
      };
    }

    componentDidMount() {
      // const lists = this.makeLists(this.props.list);
    }

    // makeLists = lists => {
    //   return lists.map(list => {
    //     return list.list.map(item => {
    //       return (
    //         <li key={item.name}>
    //           <Link to={item.name}> {item.title} </Link>
    //         </li>
    //       );
    //     });
    //   });
    // }

    render() {

      // const lists = this.makeLists(this.props.list);
      const lists = this.props.list || [];

      return (
        <Widget
          gray
          padding={false}
          tabs={['پر بازدیدترین', 'پر بحث‌ترین', 'آخرین اخبار']}
        >
          <BulletList list={lists[0] && lists[0].list} />
          <BulletList list={lists[1] && lists[1].list} />
          <BulletList list={lists[2] && lists[2].list} />
        </Widget>
      );
    }
}

const Component = withStyles(styles)(WidgetTopNews);
export {Component as WidgetTopNews}